/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageBlogResponse = {
    id?: number;
    bootCampCategory?: LandingPageBlogResponse.bootCampCategory;
    sequence?: number;
    title?: string;
    contents?: string;
    imgUrl?: string;
    forwardLink?: string;
};

export namespace LandingPageBlogResponse {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

